export default __webpack_public_path__ + "media/IonEyeDefault.29ca423b.svg";